import React from "react";
import { language } from "../../../languageProvider/language/language";
import { defaultLanguage } from "../../../helper/utility";

/**
 * Sticky horizontal chips row with filter button.
 *
 * Props:
 *  - categories: Array<{ id, name, logo }>
 *  - selectedCategoryName: string ("" = "Tutti")
 *  - onSelect(nameOrNull): cb
 *  - onFilterButtonClick(): cb
 *  - filterCount: number  // count of tag+promo+brand+onSale filters applied (badge)
 *  - hasAnyFilter: boolean  // false → hide filter button (no tags/promos/brands available)
 */
const CategoryChipsRow = ({
  categories = [],
  selectedCategoryName = "",
  onSelect,
  onFilterButtonClick,
  filterCount = 0,
  hasAnyFilter = true,
}) => {
  const tuttiLabel =
    (language[defaultLanguage] && language[defaultLanguage].tutti) || "Tutti";
  const apriFiltriLabel =
    (language[defaultLanguage] && language[defaultLanguage].apri_filtri) ||
    "Apri filtri";

  const allActive = !selectedCategoryName;

  return (
    <div
      className={`pf-row ${!hasAnyFilter ? "pf-row--no-filter-btn" : ""}`}
      role="region"
      aria-label={apriFiltriLabel}
    >
      {hasAnyFilter && (
        <button
          type="button"
          className="pf-filter-btn"
          aria-label={apriFiltriLabel}
          onClick={onFilterButtonClick}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
          >
            <line x1="4" y1="6" x2="20" y2="6" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="18" x2="20" y2="18" />
            <circle cx="9" cy="6" r="2" fill="#fff" />
            <circle cx="15" cy="12" r="2" fill="#fff" />
            <circle cx="8" cy="18" r="2" fill="#fff" />
          </svg>
          {filterCount > 0 && (
            <span className="pf-filter-btn__badge" aria-hidden="true">
              {filterCount >= 10 ? "9+" : filterCount}
            </span>
          )}
        </button>
      )}

      <div className="pf-chips" role="tablist">
        <button
          type="button"
          className={`pf-chip ${allActive ? "pf-chip--active" : ""}`}
          aria-pressed={allActive}
          onClick={() => onSelect && onSelect(null)}
        >
          <span className="pf-chip__label">{tuttiLabel}</span>
        </button>

        {categories.map((cat) => {
          const isActive = cat.name === selectedCategoryName;
          return (
            <button
              key={cat.id != null ? cat.id : cat.name}
              type="button"
              className={`pf-chip ${cat.logo ? "pf-chip--with-logo" : ""} ${
                isActive ? "pf-chip--active" : ""
              }`}
              aria-pressed={isActive}
              onClick={() => onSelect && onSelect(cat.name)}
              title={cat.name}
            >
              {cat.logo && (
                <img
                  className="pf-chip__logo"
                  src={cat.logo}
                  alt=""
                  aria-hidden="true"
                />
              )}
              <span className="pf-chip__label">{cat.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryChipsRow;
